import { useDocumentUploader } from '@/hooks/useDocumentUploader'
import {
  IDocumentsFormValues,
  IUploaderProps,
  TUploadedFile
} from '@/types/uploader'
import { Alert } from '@dgshahr/ui-kit'
import FileUploader, { FileType } from '@dgshahr/ui-kit/Form/FileUploader'

const CompanyStatute = ({ formik, corrections }: IUploaderProps) => {
  const { values } = formik
  const { handleUpload, handleDelete } = useDocumentUploader(formik)

  const fieldName = 'COMPANY_ARTICLES_OF_ASSOCIATION'

  const handleChange = (file: File | undefined) =>
    file && handleUpload(fieldName, file)

  const handleDeleteFile = (
    fieldName: keyof IDocumentsFormValues,
    e: TUploadedFile
  ): void => {
    handleDelete(fieldName, e)
  }

  return (
    <div className="flex flex-col gap-8">
      {corrections?.[fieldName] && (
        <div className="flex flex-col gap-4">
          <Alert
            size="small"
            title="اصلاحیه‌"
            variant="error"
            text={corrections[fieldName].comment}
          />
        </div>
      )}
      <label htmlFor="company-statute" className="font-p2-medium text-gray-500">
        تصویر تمامی صفحات اساسنامه شرکت را بارگذاری کنید.
      </label>

      <FileUploader
        className="w-fit"
        fileInputProps={{
          id: 'company-statute',
          className: 'ss02',
          description: 'فرمت‌های قابل قبول PNG , SVG یا PDF\nحداکثر حجم تا 5Mb',
          helperProps: {
            hintMessage: ''
          },
          title: 'تصاویر اساسنامه شرکت',
          accept:
            'image/png, image/jpeg, image/jpg, image/PNG, image/JPEG, image/JPG , application/pdf'
        }}
        mode="multiple"
        files={values[fieldName] as FileType[]}
        onChange={handleChange}
        previewProps={{
          leftButton: {
            onClick: (e) => handleDeleteFile(fieldName, e as TUploadedFile)
          },
          rightButton: false
        }}
      />
    </div>
  )
}

export default CompanyStatute
